module.exports = __webpack_public_path__ + "static/img/edge.fcdeca6.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/promotion/common/edge.png
// module id = Y3Mr
// module chunks = 10